export default function SearchForm({
    selectedDate,
    onDateChange,
    onSubmit,
    loading,
    error,
    hasSearched,
    selectedDateLabel,
}) {
    return (
        <section className="mx-auto w-full max-w-3xl transition-all duration-300">
            <form onSubmit={onSubmit}>
                <label htmlFor="search-date" className="sr-only">
                    Search date
                </label>
                <div className="flex flex-col gap-3 rounded-2xl border border-purple-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center">
                    <input
                        id="search-date"
                        type="date"
                        className="w-full rounded-xl border border-slate-200 px-3 py-2 text-base text-slate-800 shadow-sm focus:border-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-200 sm:flex-1"
                        value={selectedDate}
                        onChange={onDateChange}
                    />
                    <button
                        type="submit"
                        className="inline-flex items-center justify-center rounded-xl bg-logo-pink px-4 py-2 font-semibold text-white shadow-sm transition hover:bg-purple-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400 disabled:cursor-not-allowed disabled:opacity-60"
                        disabled={loading}
                    >
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                </div>
                {hasSearched && selectedDateLabel && (
                    <p className="mt-2 text-sm text-slate-500">
                        Showing results for <span className="font-medium">{selectedDateLabel}</span>
                    </p>
                )}
                {error && (
                    <div className="mt-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700 shadow-sm">
                        {error}
                    </div>
                )}
            </form>
        </section>
    )
}
